export default {
  articlesData: (state) => {
    return state.articlesData;
  },
};
